import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import card1 from '../assets/images/primary-market/card1.png';
import card2 from '../assets/images/primary-market/card2.png';
import card3 from '../assets/images/primary-market/card3.png';
import artistPic from '../assets/images/primary-market/profile-picture.png';

class ClosedCollection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Hero slider start */}
                <div className="container-fluid">
                    <Link to="/Collection">
                        <div className="row primary-market-header justify-content-center">
                            <div className="header-text col-lg-7 col-sm-12">
                            </div>
                            <div className="col-lg-4 col-sm-10 artist text-center">
                                <span>Disclosure</span>
                                <h6>Many Faces Open Editions by Disclosure & Friends</h6>
                                <h1>March 19</h1>
                                <p>1:30 PM EST Drawings</p>
                                <p>2:30 PM EST Open Editions</p>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* Hero slider end */}

                {/* Collection content area start */}
                <div className="container mb-5 margin-70 text-center collection-content">
                    <div className="row justify-content-center">
                        <div className="col-md-10 text-center">
                            <h3>Duke Dumont, LOREM, and MattAttack team up for 5 minute open edition!!</h3>
                            <p>“DREAM LOGIC” is a collection from Multi-platinum, GRAMMY® nominated artist Duke Dumont, in collaboration with fellow artists LOREM & MattAttack. The trio formulated the collection to conjure dreamlike states, themed around Mind & Matter.</p>
                            <p>
                                Duke Dumont says, “My goal for the collection is to make it nonsensical too many, and make absolute sense to a few . The meaning ought to be in the eye of the beholder, not dictated by the creators.”
                            </p>
                            <p>
                                Visual artist LOREM is a self-taught creative who worked all over the world , and currently based in Germany. With the ability to define motion and precisely encapsulate the emotion within, his artworks create a deep and almost hypnotic understanding about what keeps us going and simultaneously holds us back.
                            </p>
                            <p>
                                MattAttack is an analog collage and motion artist from Athens, Georgia. Making collages out of physical materials found at garage sales, estate sales and thrift stores. His compositions centered around abstract and alternate reality themes with a future-nostalgic aesthetic.</p>
                        </div>
                    </div>
                    {/* Closed COllection cards area start */}
                    <h1>Collection Closes in 2h 5m 3s</h1>
                    <div className="closed-collection text-left justify-content-center row">
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/PrimaryMarketAuction">
                                    <img src={card1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/PrimaryMarketAuction">
                                        <h3>Flower Face - Dusk</h3>
                                    </Link>
                                    <p>HIGHEST BID&emsp;<strong>$10,000</strong></p>
                                    <p className="card-text">15 Editions</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/PrimaryMarketRegularSale">
                                    <img src={card2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/PrimaryMarketRegularSale">
                                        <h3>Flower Face - Day</h3>
                                    </Link>
                                    <p>FIXED PRICE&emsp;<strong>$1,944</strong></p>
                                    <p className="card-text">6 of 15 editions REMAINING</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/PrimaryMarketRegularSale">
                                    <img src={card3} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/PrimaryMarketRegularSale">
                                        <h3>Metal Face - Bronze</h3>
                                    </Link>
                                    <p>FIXED PRICE&emsp;<strong>$111</strong></p>
                                    <p className="card-text">400 OF 453 editions REMAINING</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/PrimaryMarketAuction">
                                    <img src={card1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/PrimaryMarketAuction">
                                        <h3>Metal Face - Silver</h3>
                                    </Link>
                                    <p>HIGHEST BID&emsp;<strong>$13,944</strong></p>
                                    <p className="card-text">8 EDITIONS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Closed COllection cards area end */}

                    {/* Why love arae start */}
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <h3>Why we love Disclosure</h3>
                            <Link to="/UserProfileArtist"><img src={artistPic} alt="artistPic" className="collection-artist-pic" /></Link>
                            <p>Brothers Guy & Howard Lawrence have honed their craft as producers, musicians, songwriters & performers over the last 10 years. They have headlined countless festivals & iconic venues all over the world, as well as earning a grammy nomination for every album they have ever made. With number 1 albums & platinum records under their belts, they have achieved a lot in the music world. Now, it's time for them to bring their unique process of collaboration & creativity to the visual art space. We are so pleased to welcome them for their Nifty debut!
                            </p>
                            <h3>Follow Disclosure to receive exclusive release info</h3>
                            <button>Follow</button>
                            <h3>Learn More about Disclosure</h3>
                            <h6><Link to="#">https://website.com</Link></h6>
                            <h6><Link to="#">https://socialmedia.com</Link></h6>
                        </div>

                    </div>
                    {/* Why love arae end */}
                </div>
                {/* Collection content area end */}
            </div >
        )
    }
};

export default ClosedCollection;